import { render } from "./AddToReturnBoxConfirmModal.vue?vue&type=template&id=7215aaa2"
import script from "./AddToReturnBoxConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddToReturnBoxConfirmModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/parts/modal/AddToReturnBoxConfirmModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7215aaa2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7215aaa2', __exports__)) {
    console.log('reload')
    api.reload('7215aaa2', __exports__)
  }
  
  module.hot.accept("./AddToReturnBoxConfirmModal.vue?vue&type=template&id=7215aaa2", () => {
    console.log('re-render')
    api.rerender('7215aaa2', render)
  })

}


export default __exports__